import { Schema } from "effect";
import { ResourceBindingName, ResourceWorkspaceId } from "@workerstation/shared/resources/http";
import { R2Catalog } from "@workerstation/shared/resources/object-queue";

export type R2Binding = typeof R2Catalog.Type.bindings[number];
export const R2Target = Schema.Struct({ workspaceId: Schema.String, bindingName: Schema.String, namespace: Schema.String });
export type R2Target = typeof R2Target.Type;
export const PreparedR2Target = Schema.Struct({ workspaceId: ResourceWorkspaceId, bindingName: ResourceBindingName, namespace: Schema.String.pipe(Schema.brand("FrontendR2Namespace")) });
export const R2Download = Schema.Struct({ url: Schema.String, filename: Schema.String });
export type R2Download = typeof R2Download.Type;
export const r2TargetKey = (target: R2Target): string => JSON.stringify([target.workspaceId, target.bindingName, target.namespace]);
